module.exports = __webpack_public_path__ + "./fonts/MuseoSans_300_Italic.otf";